// Module
var code = "<div> <div class=\"ibox-header\"> <button type=\"button\" class=\"close\" datadismiss=\"modal\" aria-hidden=\"true\" ng-click=\"close()\">&times;</button> </div> <div class=\"ibox-content\"> <canvas_paint save-event=\"saveEvent(imgData)\" clear-event=\"clearEvent()\"></canvas_paint> </div> </div> ";
// Exports
module.exports = code;